export default __webpack_public_path__ + "static/media/fan-art-iteration-3.fa368132.jpeg";